<template>
    <div>
        <Steps :profileSteps="referenceSteps" :activeStep="this.$route.meta.pageNumber" :componentWidth="'600px'"/>
        <router-view ref="child"></router-view>
        <v-row class="row-height-80" justify="center">
                <v-col cols="12" md="6" lg="6" sm="12">
                    <v-row justify="space-between">
                        <v-col class="col-3 row-height-80">
                            <button :disabled="submitting || this.$route.meta.pageNumber === 1" class="back-button back-button-text" @click="previousPage">BACK</button>
                        </v-col>            
                        <v-col class="row-height-80" cols="6">
                            <button v-if="!submitting" :disabled="!form.valid || submitting" :style="cssVars" class="submit-button submit-button-text" @click="nextPage">{{this.$route.meta.pageNumber === this.totalPages ? 'SUBMIT DECLARATION':'SAVE & NEXT'}}</button>
                            <button v-else class="submit-button submit-button-text"><span class="spin">&bull;</span></button>
                        </v-col>
                    </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Steps from '../ProfileProgressComponent';


export default {
    props: {             
        totalPages: Number, 
    },
    components: {
        Steps
    },
    data: function() {
        return {
            form: {valid: false},
            submitting: false,
            endorse_reason_min: 0,
            endorse_reason_max: 0,
            referenceSteps:{
                1: "My Details",
                2: "",
                3: "Endorsement",
                4: "",
                5: "Declaration"
            }             
        }
    },
    computed: {
        reference() {
            return this.$parent.reference
        },
        cssVars() {
            return {
                '--submit-button-color': this.form.valid ? '#ea7f1d' : '#d5d5d5',
                '--submit-button-text-color': this.form.valid ? '#ffffff' : '#8e8e8c'
            }
        }
    },
    methods:{
        async nextPage(){
            this.submitting = true;

            if(!this.$refs.child.$refs.form.validate()){
                this.submitting = false;
                setTimeout(() => {
                    const el = document.getElementsByClassName('error-text')[0];
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 500)
                return
            }
            
            if(this.$route.meta.pageNumber < this.totalPages){
                await this.$parent.saveReference()
                this.$router.push({name: `guardian.${this.$route.meta.pageNumber+1}`})
                this.submitting = false;
                return;
            }

            this.reference['Feedback_Submitted__c'] = true;
            await this.$parent.saveReference();
            this.$parent.submitted = true;
            
        },
        previousPage(){
            this.submitting = true;
            
            if(this.$route.meta.pageNumber > 1){
                this.$router.push({name: `guardian.${this.$route.meta.pageNumber-1}`})
            }
            this.submitting = false;
        },
    }
}
</script>

<style lang="scss" scoped>
.submit-button
{
    margin-top: 30px;
    width: 100%;
    height: 48px;
    border-radius: 3px;
    border: solid 2px var(--submit-button-color);
    background-color: var(--submit-button-color);
} 

.back-button
{
    margin-top: 30px;
    width: 109px;
    height: 48px;
    border-radius: 3px;
    border: solid 2px #4d4d4d;
}

.button-text
{
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    text-align: center;
}

.back-button-text
{
    @extend .button-text;
    color: #4d4d4d;
}

.submit-button-text
{
    @extend .button-text;
    color: var(--submit-button-text-color);
}

.spin {
    color: white;
    display: flex;
    justify-content: center;
    -webkit-animation: dotting 2s infinite;
    -o-animation: dotting 2s infinite;
    animation: dotting 2s infinite;
}


@keyframes dotting {
    0% {
        text-shadow: 0 0 0 currentColor;
    }
    33% {
        text-shadow: -20px 0 0 currentColor;
    }
    66% {
        text-shadow: -20px 0 0 black, 20px 0 0 currentColor;
    }
    100% {
        text-shadow: 0px 0 0 currentColor;
    }
}

</style>
